import { render, staticRenderFns } from "./file-view.vue?vue&type=template&id=55a0e91a&"
import script from "./file-view.vue?vue&type=script&lang=js&"
export * from "./file-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports